import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import fundo from "../../../../styles/fundo.svg";
import { ImBin } from "react-icons/im";
import Swal from "sweetalert2";
import './style.css'
import { useUploadAnexo } from "./UploadAnexo.js";

const FormContainer = styled.form`
  width: auto;
  background-color: #f4f4f5;
  display: flex; 
  align-items: flex-start;
  flex-direction: row;

`;

const DivContainer = styled.form`
  width: auto;
  background-color: #f4f4f5;
  display: flex; 
  align-items: flex-start;
  flex-direction: column;

`;

const Div = styled.div`
  width:95%;
  background-color: #f4f4f5;
  display: flex; 
  padding: 20px 10px 10px 10px;
  align-items: flex-end;
  gap: 20px 0px;
  flex-direction: row;
 
`;

const DivButtons = styled.div`
  max-width:100%;
  background-color: #f4f4f5;
  display: flex; 
  padding: 5px 0px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin-left: 20px;
`;



const TextAreaContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: auto;
  
  
`;

const InputArea = styled.div`
  width: auto;
  height: auto; 
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 0px 10px;

  select {
    width: 210px;
    height: 40px;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 0px 10px;
    background-color: #f4f4f5;
    font-size: 18px;
    color: #3a3f42;
  }
`;

const InputTitle = styled.textarea`
  min-width: 600px; 
  min-height: 150px;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 10px 10px 00px 20px;
  background-color: #f4f4f5;
  resize: none; /* Desabilitar o redimensionamento manual */
  box-sizing: border-box; /* Incluir o padding e a borda na largura total */
  overflow: auto; /* Permitir a rolagem automática */
  white-space: pre-wrap; /* Manter quebras de linha e espaços */
  color: #3a3f42;
  font-size: 18px;
`;

const InputDescricao = styled.textarea`
  min-width: 600px; 
  min-height: 300px;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 10px 10px 00px 20px;
  background-color: #f4f4f5;
  resize: none; /* Desabilitar o redimensionamento manual */
  box-sizing: border-box; /* Incluir o padding e a borda na largura total */
  overflow: auto; /* Permitir a rolagem automática */
  white-space: pre-wrap; /* Manter quebras de linha e espaços */
  color: #3a3f42;
  font-size: 18px;
`;


const Input = styled.input`
  width: 130px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 0px 10px;
  background-color: #f4f4f5;
  font-size: 16px;
  color: #3a3f42;
`;

const Label = styled.label`
  color: #3a3f42;
  font-weight: bold;
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  margin: 0px 5px;
  padding: 0px 0px 0px 10px; 


`;

const Table = styled.table`
  width: 800px;
  background-color: #f4f4f5;
  padding: 5px 5px;
`;


const Tr = styled.tr`
  display: flex; 
  justify-content: space-between;
  text-align: center;
  padding-bottom: 05px;

`;

const Button = styled.button`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 10px ;
  cursor: pointer;
  border: none;
  background-image: url(${fundo});
  color: #fff;
  font-size: bold;
  font-size: 20px;
  gap: 5px;
  margin-top: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;


`;




const A = styled.a`
  text-decoration: none;
  padding: 0px 0px 0px 10px; 
  margin: 0px 0px 0px 10px; 
  color: #3a3f42;
`;



export const Td = styled.td`
  font-size: 16px;
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;

`;

export const Thead = styled.thead``;

export const Tbody = styled.tbody`
  padding-bottom: 05px; 
`;

export const Th = styled.th`
  text-align: start;
  border-bottom: inset;
  padding-bottom: 5px;
  color:  #3a3f42;
`;

const Hr = styled.div`
  display: flex;
  align-items: center; /* Alinha ao centro verticalmente */
  width: 95%; /* Largura total */
  height: 1px; /* Altura da linha */
  background-color: #ccc;
  justify-content: center;
  margin-left: 5%;
  margin: 25px 0px;
`;


const Form = ({ urlApi, setOnEdit, fetchCheckbox, fetchAnexos, anexosTarefa, modalInfTarefa, infTarefa, card, editarCartao, verQuadro }) => {
  const ref = useRef();

  //Token da api
  const token = localStorage.getItem('token');
  const id = Number(localStorage.getItem('id'));


  //---------------------------CARREGA OS DADOS PARA O FORM--------------------------------------//
  useEffect(() => {
    if (infTarefa && ref.current) {
      const user = ref.current;

      user.nome_criador.value = infTarefa.NOME_CRIADOR_TAREFA || '-';
      user.descricao_check.value = infTarefa.DESCRICAO_TAREFA || '-';
      user.data_criacao.value = infTarefa.DATA_CRIACAO || '-';
      user.data_conclusao.value = infTarefa.DATA_CONCLUSAO || '-';
      user.data_inicio.value = infTarefa.DATA_INICIO || '-';
      user.resposta_check.value = infTarefa.RESPOSTA_TAREFA || '';
      user.valor.value = infTarefa.VALOR_TAREFA != null ? infTarefa.VALOR_TAREFA : '';

      setSituacao(infTarefa.SITUACAO || ''); // ✅ agora controlado por useState
    }
  }, [infTarefa]);


  //-------------------------CONVERTE O CODIGO DA SITUAÇÂO-------------------------------------------------//
  const [situacao, setSituacao] = useState('');
  const opcoesSituacao = {
    AF: "A Fazer",
    PR: "Programado",
    AN: "Em Andamento",
    VA: "Em Validação",
    PA: "Pausado",
    CO: "Concluído",
    CA: "Cancelado",
    AR: "Arquivado",
  };


  //----------------------------------SALVA OS DADOS-------------------------//
  const handleSubmit = async (e) => {
    e.preventDefault();
    const user = ref.current;

    const resposta_checkValue = user.resposta_check.value;

    if (!resposta_checkValue || !situacao) {
      return toast.warn("Preencha todos os campos obrigatórios!");
    }

    try {
      await axios.put(
        `${urlApi}painel-monitoramento/resposta-tarefa/${infTarefa.ID_TAREFA}`,
        {
          resposta_tarefa: resposta_checkValue,
          situacao: situacao,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      toast.success("Tarefa atualizada com sucesso.");

      setTimeout(() => {
        modalInfTarefa(); // fecha modal
      }, 1000);
    } catch (error) {
      if (error.response) {
        const errorMessage = error.response.data.error || "Erro desconhecido";
        const details = error.response.data.details;
        const dbError = error.response.data.dbError;

        console.error("Error:", errorMessage);
        console.error("Details:", details);
        console.error("Database Error:", dbError);

        toast.error("Erro ao salvar os dados: " + errorMessage);
      } else {
        console.error("Erro de rede ou no servidor:", error.message);
        toast.error("Erro ao salvar os dados. Por favor, tente novamente.");
      }
    } finally {
      fetchCheckbox();   // Atualiza os dados visuais
      setOnEdit(null);   // Limpa a edição ativa
    }
  };


  //------------------------------------------PODE EDITAR----------------------//
  const podeEditarFull = id === editarCartao?.ID_CRIADOR || id === editarCartao?.ID_COCRIADOR || id === infTarefa?.ID_RESPONSAVEL_TAREFA || id === editarCartao?.ID_RESPONSAVEL;
  const quadroLivre = verQuadro?.LIVRE === 'S';



  //-------------------------------UPLOAD ANEXO CARTAO ---------------------------------//  

  const { uploadAnexo, uploadStatus } = useUploadAnexo(urlApi, token, fetchAnexos);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    uploadAnexo(file, null, infTarefa.ID_TAREFA, id);
  };
  //-------------------------------DOWNLOAD ANEXO ---------------------------------// 
  const downloadArquivo = async (nomeSalvo) => {
    try {
      const response = await axios.get(`${urlApi}painel-monitoramento/download/${nomeSalvo}`, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeSalvo);
      document.body.appendChild(link);
      link.click();
      link.remove();

    } catch (error) {
      console.error("Erro ao baixar arquivo:", error);
    }
  };


  //------------------------DELETA ANEXO-----------------------------------------------//

  const showPopUp = () => {
    return new Promise((resolve) => {
      Swal.fire({
        title: `Essa ação é irreversível, tem certeza que gostaria de continuar?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: 'custom-swal-container', // Estiliza o container principal
          title: 'custom-swal-title', // Estiliza o título
          confirmButton: 'custom-swal-confirm-button', // Estiliza o botão de confirmação
          cancelButton: 'custom-swal-cancel-button', // Estiliza o botão de cancelamento
          popup: 'custom-swal-popup', // Estiliza o popup
          icon: 'custom-swal-icon' // Estiliza o ícone
        },
      }).then((result) => {
        resolve(result.value); // Resolve a Promise com o valor result.value
      });
    });
  };


  const handleDeleteAnexo = async (id_anexo, id_cartao = null, id_tarefa = null) => {

    const userConfirmed = await showPopUp();
    if (!userConfirmed) return;

    try {
      const params = {};

      if (id_cartao) params.id_cartao = id_cartao;
      if (id_tarefa) params.id_tarefa = id_tarefa;

      await axios.delete(`${urlApi}painel-monitoramento/deletar/${id_anexo}`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });

      toast.success("Anexo deletado com sucesso!");
      fetchAnexos();
      return true; // sucesso
    } catch (error) {
      console.error("Erro ao deletar anexo:", error);
      toast.error("Erro ao deletar anexo.");
      return false; // erro
    }
  };





  return (
    <div >
      <FormContainer>


        <DivContainer ref={ref} onSubmit={handleSubmit}>
          <Div>
            <TextAreaContainer>
              <InputTitle
                id="descricao_check"
                readOnly
                disabled
              />
            </TextAreaContainer>
          </Div>
          <Div>
            <InputArea>
              <Label>Criador:</Label>
              <Input
                id="nome_criador"
                name="nome_criador"
                readOnly
              />
            </InputArea>
            <InputArea>
              <Label>Criado:</Label>
              <Input
                id="data_criacao"
                name="data_criacao"
                readOnly
              />
            </InputArea>

            <InputArea>
              <Label>Valor:</Label>
              <Input
                id="valor"
                name="valor"
                readOnly
              />
            </InputArea>
          </Div>

          <Div>
            <InputArea>
              <Label>Data conclusão:</Label>
              <Input
                id="data_conclusao"
                name="data_conclusao"
                readOnly
                disabled
              />
            </InputArea>

            <InputArea>
              <Label>Data Início:</Label>
              <Input
                id="data_inicio"
                name="data_inicio"
                readOnly
                disabled
              />
            </InputArea>

            <InputArea>
              <Label>Data de entrega:</Label>
              <Input
                id="meta_conclusao"
                name="meta_conclusao"
                readOnly
                disabled
              />
            </InputArea>


          </Div>
          <Div><Hr /></Div>

          <Div>

            <TextAreaContainer>
              <InputArea>

                <Label>Situação:</Label>
                <select
                  name="situacao"
                  value={situacao}
                  onChange={(e) => setSituacao(e.target.value)} // ✅ controla a mudança
                >
                  <option value="" disabled>Escolha...</option>
                  {Object.entries(opcoesSituacao).map(([valor, label]) => (
                    <option key={valor} value={valor}>{label}</option>
                  ))}
                </select>


              </InputArea>
              <InputArea>
                <Label>Resposta</Label>
                <InputDescricao
                  id="resposta_check"
                  name="resposta_check"
                  placeholder="Digite a resposta da tarefa aqui..."
                />
              </InputArea>


              <Div>
                <section>
                  <Label>Arquivos anexados:</Label>

                  <div style={{ marginTop: "8px", marginBottom: "16px" }}>
                    {anexosTarefa.length > 0 ? (
                      <Table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <Tbody>
                          {anexosTarefa.map(anexo => (
                            <Tr key={anexo.ID_ANEXO}>
                              <Td
                                style={{
                                  padding: "8px 16px",
                                  textAlign: "left",
                                  whiteSpace: "nowrap"
                                }}
                              >
                                <span
                                  style={{
                                    width: "80%",
                                    color: "#007bff",
                                    textDecoration: "underline",
                                    cursor: "pointer"
                                  }}
                                  onClick={() => downloadArquivo(anexo.NOME_SALVO)}
                                >
                                  {anexo.NOME_ORIGINAL}
                                </span>
                              </Td>
                              <Td
                                style={{
                                  padding: "8px 16px",
                                  textAlign: "left",
                                  whiteSpace: "nowrap",
                                  color: "#333"
                                }}
                              >
                                {anexo.DATA_CRIACAO}
                              </Td>
                              {(podeEditarFull || quadroLivre) && (
                                <Td
                                  style={{
                                    padding: "8px 16px",
                                    textAlign: "left"
                                  }}
                                >
                                  <button
                                    type="button"
                                    onClick={() => handleDeleteAnexo(anexo.ID_ANEXO)}
                                    style={{
                                      background: "none",
                                      border: "none",
                                      color: "red",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "4px"
                                    }}
                                  >
                                    <ImBin color="Red" />
                                    Deletar
                                  </button>
                                </Td>
                              )}
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>

                    ) : (
                      <p style={{ color: "#888" }}>Nenhum arquivo anexado.</p>
                    )}
                  </div>
                </section>
              </Div>

              <Div>
                {podeEditarFull || quadroLivre ? (
                  <section style={{ marginTop: "24px" }}>
                    <Label>Adicionar novo anexo:</Label>

                    <div style={{ marginTop: "8px" }}>
                      <input
                        type="file"
                        onChange={handleFileChange}
                        style={{
                          padding: "6px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          width: "100%",
                          cursor: "pointer",
                        }}
                      />
                    </div>

                    {uploadStatus && (
                      <p style={{ marginTop: "8px", fontSize: "14px", color: uploadStatus.includes("sucesso") ? "green" : "red" }}>
                        {uploadStatus}
                      </p>
                    )}
                  </section>
                ) : null}
              </Div>

              <InputArea>

                <DivButtons>
                  {(podeEditarFull || quadroLivre) && (
                    <Button
                      title="Salvar"
                      type="submit"
                      onClick={handleSubmit}
                    >
                      Salvar
                    </Button>
                  )}
                </DivButtons>

              </InputArea>
            </TextAreaContainer>

          </Div>
        </DivContainer>

      </FormContainer>
      <style jsx global>{`
      .swal2-container.custom-swal-container {
        z-index: 9999; 
      }
    `}</style>
    </div>

  );
};

export default Form;


